import { RouterParams } from './interfaces/IRouter';

// Passthrough de /continuando: não veta nada, só encaminha para o próximo elo da
// cadeia (e daí para o terminador, que é quem chama o `next` do router).
const continueMiddleware = ({ next }: RouterParams) => {
  return next();
};

export { continueMiddleware };
